import { Component } from '@angular/core';
import { IApp } from '@core/models/app.interfaces';
import { UntilDestroy } from '@ngneat/until-destroy';
import { FieldType } from '@ngx-formly/core';

@UntilDestroy()
@Component({
  selector: 'formly-documents',
  template: `
    <ng-container *ngIf="documentUploadConfig && !field.hide">
      <app-documents
        [documentUploadConfig]="documentUploadConfig"
        (documentResult)="documentUploadHandler($event)"
        [disabled]="fieldDisabled"
        [showPlaceholders]="true">
      </app-documents>
    </ng-container>
  `,
})
// tslint:disable-next-line:component-class-suffix
export class FormlyDocumentsTypeComponent extends FieldType {

  public documents: IApp.IDocument[];
  public isDocumentUploadInProgress = false;
  public documentUploadDisabled = false;

  constructor() {
    super();
  }

  get fieldDisabled() {
    return this.documentUploadDisabled || this.form.disabled;
  }

  documentUploadHandler(documentResult: IApp.IEmmitedDocs): void {
    this.documents = <IApp.IDocument[]>documentResult.docs;
    this.isDocumentUploadInProgress = documentResult.docs
      .filter(document => document._uploadStatus)
      .some(document => document._uploadStatus !== 'CLEAN');
    if (typeof this.props.onDocumentsChange === 'function') {
      this.props.onDocumentsChange(documentResult);
    }
  }

  private _hasDocumentConfigs() {
    return this.documentUploadConfig &&
      this.documentUploadConfig.documentUploadConfigs;
  }

  public get documentUploadConfig(): IApp.IDocumentUploadConfig {
    return this.props.documentUploadConfig;
  }

}
